var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilverIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#E2E2E4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9999,
    cy: 13,
    r: 9.1,
    fill: "#B0B0BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2403 16.5089L15.8792 18.1049C16.3624 18.3974 16.9538 17.965 16.8266 17.4182L16.1271 14.4169L18.4607 12.3949C18.8868 12.0261 18.6579 11.3267 18.0983 11.2821L15.0271 11.0214L13.8253 8.18551C13.6091 7.67046 12.8715 7.67046 12.6553 8.18551L11.4536 11.0151L8.38237 11.2758C7.82282 11.3203 7.59391 12.0197 8.01993 12.3885L10.3535 14.4106L9.65409 17.4118C9.52692 17.9587 10.1183 18.3911 10.6015 18.0986L13.2403 16.5089Z",
    fill: "#E2E2E4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverIcon);
export default __webpack_public_path__ + "static/media/silverIcon.8fb0c6e2bad8bfa14310321aeecb6928.svg";
export { ForwardRef as ReactComponent };